<div id="gridComponent" class="grid-container" *ngIf="calsPortfolioPageGrid && calsPortfolioPageGrid.filtersForm">
  <div class="grid-message p-a" [hidden]="calsPortfolioPageGrid && calsPortfolioPageGrid?.total">
    <div [hidden]="!calsPortfolioGridInProgress" class="loader">loader</div>
    <p [hidden]="calsPortfolioGridInProgress">No Records Found.</p>
  </div>

  <div class="hr-scrolable-table stripe-table" *ngIf="calsPortfolioPageGrid && calsPortfolioPageGrid?.dataSource?.data?.length > 0">
    <table mat-table [dataSource]="calsPortfolioPageGrid.dataSource" matSort class="mat-elevation-z1 mat-table mat-small stripe-table">
      <!-- Instrument Code Column -->
      <ng-container matColumnDef="instrumentCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="nowrap-header text-left">Instr. Code</th>
        <td mat-cell *matCellDef="let dataItem">
          <span
            >{{ dataItem.instrumentCode }}
            <a title="view company profile" class="code-url ml-3" (click)="gotoResearchPortal(dataItem.instrumentCode)">
              <img class="mb-2" src="/assets/images/trans-sum-arrow.svg" height="15" alt="View" />
            </a>
          </span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- Total Qty Column -->
      <ng-container matColumnDef="totalStock">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="nowrap-header text-end">
          <span class="justify-content-end">Total Qty</span>
        </th>
        <td mat-cell *matCellDef="let dataItem" class="text-end">
          <span class="me-3">{{ dataItem.totalStock | number : 0 : false }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <!-- Saleable Qty Column -->
      <ng-container matColumnDef="saleable">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="nowrap-header text-end">
          <span class="justify-content-end">Saleable Qty</span>
        </th>
        <td mat-cell *matCellDef="let dataItem" class="text-end">
          <span class="me-3">{{ dataItem.saleable | number : 0 : false }}</span>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <!-- Average Cost Column -->
      <ng-container matColumnDef="avgCost">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="nowrap-header text-end">
          <span class="justify-content-end">Average Cost</span>
        </th>
        <td mat-cell *matCellDef="let dataItem">
          <div style="white-space: nowrap" class="text-end">
            <span class="me-3">{{ dataItem.avgCost | number : 2 : true }}</span>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <!-- Total Cost Column -->
      <ng-container matColumnDef="totalCost">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="nowrap-header text-end">
          <span class="justify-content-end">Total Cost</span>
        </th>
        <td mat-cell *matCellDef="let dataItem">
          <div style="white-space: nowrap" class="text-end">
            <span class="me-3">{{ dataItem?.totalCost | number : 2 : true }}</span>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <div style="white-space: nowrap" class="text-end">
            <span class="me-3"
              ><b>{{ calsPortfolioGridInProgress ? '' : (equityPortfolio?.totalCost | number : 2 : false) }}</b></span
            >
          </div>
        </td>
      </ng-container>
      <!-- Market Rate Column -->
      <ng-container matColumnDef="marketRate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="nowrap-header text-end">
          <span class="justify-content-end"> Market Rate</span>
        </th>
        <td mat-cell *matCellDef="let dataItem">
          <div class="text-end">
            <span class="me-3">{{ dataItem.marketRate | number : 2 : true }} </span>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <!-- Market Value Column -->
      <ng-container matColumnDef="marketValue">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="nowrap-header text-end">
          <span class="justify-content-end">Market Value</span>
        </th>
        <td mat-cell *matCellDef="let dataItem">
          <div class="text-end">
            <span class="me-3">{{ dataItem.marketValue | number : 2 : true }}</span>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <div class="text-end">
            <span
              ><b>{{ calsPortfolioGridInProgress ? '' : (equityPortfolio.marketValue | number : 2 : false) }}</b></span
            >
          </div>
        </td>
      </ng-container>
      <!-- Unrealized Gain Column -->
      <ng-container matColumnDef="unrealizedGain">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="nowrap-header text-end">
          <span class="justify-content-end">Unrealized Gain</span>
        </th>
        <td mat-cell *matCellDef="let dataItem">
          <div style="white-space: nowrap" class="text-end">
            <span class="me-3">{{ dataItem.unrealizedGain | number : 2 : true }}</span>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <div style="white-space: nowrap" class="text-end">
            <span
              ><b>{{ calsPortfolioGridInProgress ? '' : (equityPortfolio.totalUnrealizedGain | number : 2 : false) }}</b></span
            >
          </div>
        </td>
      </ng-container>
      <!-- % Gain Column -->
      <ng-container matColumnDef="gainPercentage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="nowrap-header text-end">
          <span class="justify-content-end">% Gain</span>
        </th>
        <td mat-cell *matCellDef="let dataItem" [ngClass]="dataItem.gainPercentage > 0 ? 'increase' : 'decrease'">
          <div style="white-space: nowrap" class="text-end market-gain">
            <span class="me-3">{{ dataItem.gainPercentage | number : 2 : true }}</span>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <!-- % Mkt. Value Column -->
      <ng-container matColumnDef="marketValuePercentage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="nowrap-header text-end">
          <span class="justify-content-end">% Mkt. Value</span>
        </th>
        <td mat-cell *matCellDef="let dataItem">
          <div style="white-space: nowrap" class="text-end">
            <span class="me-3">{{ dataItem.marketValuePercentage | number : 2 : true }}</span>
          </div>
        </td>
        <td mat-footer-cell *matFooterCellDef class="text-end">
          <span class="me-3"><b>100.00</b></span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="calsPortfolioPageGrid.displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: calsPortfolioPageGrid.displayedColumns"></tr>
      <tr mat-footer-row *matFooterRowDef="calsPortfolioPageGrid.displayedColumns; sticky: true"></tr>
    </table>

    <mat-paginator
      [pageIndex]="calsPortfolioPageGrid.pageIndex"
      [length]="calsPortfolioPageGrid.total"
      [pageSize]="calsPortfolioPageGrid.pageSize"
      [pageSizeOptions]="[5, 10, 50, 100]"
      (page)="calsPortfolioPageGrid.onPaginate($event)"
    >
    </mat-paginator>
  </div>
  <div *ngIf="equityPortfolio && !calsPortfolioGridInProgress" class="mb-2">
    <div class="row portfolio-totals">
      <div class="col-12 text-end">Realized Gain/Loss <span> : </span>{{ equityPortfolio?.realizedGainOrLoss | number : 2 : false }}</div>
    </div>
    <div>
      <button
        class="float-end btn btn-fill mt-1 ws-loading {{ downloadingReport ? 'ws-loading-progress' : '' }}"
        (click)="downloadReport('/account/me/financial/equity-portfolio/export')"
      >
        Download Report
      </button>
    </div>
  </div>
</div>
